import $ from 'jquery';

export const currentForm = $(`form.js-FormValidation`);
export const formKey = $(currentForm).attr('id');

//export const formInputList = $(currentForm).find(`input[type=text][class*='js-'], input[type=number], input[type=tel], input[type=email], input[type=password], select, input[type=checkbox], textarea`);
export const formOptionList = $(currentForm).find(`select, input[type=checkbox]`);
export const formInputStatusList = () => $(currentForm).find(`input[valid-input="false"], textarea[valid-input="false"], select[valid-input="false"]`);

export const getFormInputList = () => {
	const domList = $(currentForm).find(`input[type=text][class*='js-'], input[type=number], input[type=tel], input[type=email], input[type=password], select, input[type=checkbox], textarea`);
	return domList;
};

// donot add js- to the non-required fields..
export const formDataMap = [
	{ formKey: "sampleForm",
	  inputList: [
	  {
	    elemKey: "js-firstName",
	    formatPattern: "[A-Za-z0-9_./#&+-]{5}",
	    messages: {
	    	"isRequired": "Please enter a valid first name" ,
		    "pattern": "Please enter a numeric and 5 digits long.",
	    }
	  },
	  {
	    elemKey: "js-lastName",
	    messages: { "isRequired": "Please enter a valid last name" }
	  },
	  {
	    elemKey: "js-subject",
	    messages: { "isRequired": "Please enter a required value country" }
	  },
	  {
	    elemKey: "js-description",
	    messages: { "isRequired": "Please enter some required text here" }
	  },
	  {
	    elemKey: "js-agreement",
	    messages: { "isRequired": "Checkbox is required" }
	  },
	  {
	    elemKey: "js-email",
	    messages: {
	      "isRequired": "Please enter a valid email address",
	      "email": "Only valid email address is allowed."
	    }
	  },
	  {
	    elemKey: "js-favNumber",
	    formatPattern: "[0-9]{5}",
	    messages: {
	      "isRequired": "Please enter a valid email address",
	      "pattern": "Please enter a numeric and 5 digits long.",
	      "email": "Only valid email address is allowed."
	    }
	  },
	  {
	    elemKey: "js-password",
	    messages: {
	      "isRequired": "Please enter a secure password"
	    }
	  },
	  {
	    elemKey: "js-passwordVerify",
	    partner: "js-password",
	    messages: {
	      "isRequired": "Please enter a secure password",
	      "partner": "Password values need to match."
	    }
	  }]
	},
  {
	  formKey: "contactForm",
	  inputList: [
		  {
			  elemKey: "js-firstName",
			  messages: { "isRequired": "Please enter a valid first name." }
		  },
		  {
			  elemKey: "js-lastName",
			  messages: { "isRequired": "Please enter a valid last name." }
		  },
		  {
			  elemKey: "js-subject",
			  messages: { "isRequired": "Please select a topic." }
          },
		  {
			  elemKey: "js-email",
			  messages: {
				  "isRequired": "Please enter a valid email address.",
				  "email": "Only valid email address is allowed."
			  }
		  },
		  {
			  elemKey: "js-desc",
			  messages: { "isRequired": "Please enter some required text here." }
		  }
	  ]
  },
  {
	  formKey: "commentForm",
	  inputList: [
		  {
			  elemKey: "js-title",
			  messages: { "isRequired": "Please enter a topic." }
          },
		  {
			  elemKey: "js-body",
			  messages: { "isRequired": "Please enter some required text here." }
		  },
		  {
			  elemKey: "js-tos",
			  messages: { "isRequired": "Please agree to the Terms and Conditions." }
		  },
	  ]
  },
  {
	  formKey: "newsLetterForm",
	  inputList: [
		  {
			  elemKey: "js-country",
			  messages: { "isRequired": "Please select a country." }
		  },
		  {
			  elemKey: "js-zipcode",
			  messages: { "isRequired": "Please enter a valid zipcode." }
		  },
		  {
			  elemKey: "js-email",
			  messages: {
				  "isRequired": "Please enter a valid email address.",
				  "email": "Only valid email address is allowed."
			  }
		  },
	      {
			  elemKey: "js-agreement",
			  messages: { "isRequired": "Checkbox is required" }
	      },
		  {
			  elemKey: "js-tos",
			  messages: { "isRequired": "Please agree to the Terms and Conditions." }
		  },
      ]
  },

  {
	  formKey: "loginForm",
	  inputList: [
		  {
			  elemKey: "js-password",
			  messages: { "isRequired": "Please enter your password." }
		  },
		  {
			  elemKey: "js-email",
			  messages: {
				  "isRequired": "Please enter a valid email address.",
				  "email": "Only valid email address is allowed."
			  }
		  },

	  ]
  },

  {
	  formKey: "resetPasswordForm",
	  inputList: [
		  {
		  	    elemKey: "js-email",
		  		messages: {
		  			"isRequired": "Please enter a valid email address.",
		  			"email": "Only valid email address is allowed."
		  		}
		  }
	  ]
  },

  {
	  formKey: "updatePasswordForm",
	  inputList: [
		  {
			  elemKey: "js-userEmail",
			  messages: {
				  "isRequired": "Please enter a valid email address.",
				  "email": "Only valid email address is allowed."
			  }
		  },
		  {
			  elemKey: "js-password",
			  formatPattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/,
			  messages: {
				   "isRequired": "Please enter a valid password.",
				   "pattern": "The password must be at least 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.",
			  }
		  },
		  {
			  elemKey: "js-passwordVerify",
			  formatPattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/,
				partner: "js-password",
			  messages: {
				   "isRequired": "Please re-enter your password.",
					 "partner": "Password values need to match.",
				   "pattern": "The password must be at least 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.",
			  }
		  },
	  ]
  },
  {
	  formKey: "changePasswordForm",
	  inputList: [
		  {
			  elemKey: "js-credential",
			  messages: { "isRequired": "Please enter a valid password." }
		  },
		  {
			  elemKey: "js-newCredential",
			  formatPattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/,
			  messages: {
				   "isRequired": "Please enter a valid password." ,
				   "pattern": "The password must be at least 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.",
			  }
		  },
		  {
			  elemKey: "js-newCredentialVerify",
			  formatPattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/,
			  partner: "js-newCredential",
			  messages: {
  					"isRequired": "Please re-enter your password.",
			      "partner": "Password values need to match.",
			      "pattern": "The password must be at least 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.",
			  }

		  },
	  ]
  },


  {
	  formKey: "subscribeStep1Form",
	  inputList: [
		  {
			  elemKey: "js-email",
			  messages: {
				  "isRequired": "Please enter a valid email address.",
				  "email": "Only valid email address is allowed."
			  }
		  },
		  {
			  elemKey: "js-password",
			  formatPattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/,
			  messages: {
				   "isRequired": "Please enter a valid password." ,
				   "pattern": "The password must be at least 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.",
			  }
		  },
		  {
			  elemKey: "js-passwordVerify",
				formatPattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/,
			  partner: "js-password",
			  messages: {
				   "isRequired": "Please enter a valid password." ,
				   "partner": "Password values need to match.",

			  }
		  },
		  {
			  elemKey: "js-userName",
			  formatPattern: "[a-z0-9\_]{3,}",
			  messages: {
				    "isRequired": "Please enter your user name." ,
				    "pattern": "Your User Name must be at least 3 characters and contain only lowercase letters, numbers, and/or _",
			  }
		  },
		  {
			  elemKey: "js-country",
			  messages: { "isRequired": "Please select a country." }
		  },

		  {
			  elemKey: "js-zipcode",
			  formatPattern: "[A-Za-z0-9 -]{1,10}",
			  messages: {
				  "isRequired": "Please enter a valid zipcode." ,
				  "pattern": "Please enter alpha-numeric value and upto 10 character long.",
			  }
		  },
		  {
			  elemKey: "js-birthDay",
			  messages: { "isRequired": "Please enter your birthday.",
				          "birthday" : "Invalid Birthday Format.",
			 }
		  },
		  {
			  elemKey: "js-tos",
			  messages: { "isRequired": "Please agree to the Terms and Conditions." }
		  },
	  ]
    },


    {
  	  formKey: "subscribeStep2Form",
  	  inputList: [
  		{
			  elemKey: "js-firstName",
			  formatPattern: "[A-Za-z ]{1,30}",
			    messages: {
			    	"isRequired": "Please enter a valid first name" ,
				    "pattern": "Valid characters are A-Z a-z 0 upto 30 character long.",
			    }
		  },
		  {
			  elemKey: "js-lastName",
			  formatPattern: "[A-Za-z ]{1,30}",
			  messages: {
				  "isRequired": "Please enter a valid last name.",
				  "pattern": "Valid characters are A-Z a-z 0 upto 30 character long.",
			  }
		  },
		  {
			  elemKey: "js-email",
			  messages: {
				  "isRequired": "Please enter a valid email address.",
				  "email": "Only valid email address is allowed."
			  }
		  },
		  {
			  elemKey: "js-country",
			  messages: {
				  "isRequired": "Please select a country.",
				  "pattern": "Valid characters are A-Z, a-z, space and  upto 30 character long.",
				    }
		  },
		  {
			  elemKey: "js-zipcode",
			  formatPattern: "[A-Za-z0-9 ]{1,10}",
			  messages: {
				  "isRequired": "Please enter a valid zipcode." ,
				  "pattern": "Please enter alpha-numeric value and upto 10 character long.",}
		  },
		  {
			  elemKey: "js-city",
			  formatPattern: "[A-Za-z0-9 _.\/#,-]{1,30}",
			  messages: {
				  "isRequired": "Please enter a city.",
				  "pattern": "Please enter alpha-numeric value and upto 30 character long."
			  }
		  },
		  {
			  elemKey: "js-address",
			  formatPattern: "[A-Za-z0-9 _.\/#,-]{1,30}",
			  messages: {
				  "isRequired": "Please enter your address.",
				  "pattern": "Please enter alpha-numeric value and upto 30 character long.",
			  }
		  },
		  {
			  elemKey: "js-address2",
			  formatPattern: "[A-Za-z0-9 _.\/#,-]{1,30}",
			  messages: {
			  		"pattern": "Please enter alpha-numeric value and upto 30 character long.",
			  }
		  },
		  {
			  elemKey: "js-state",
			  formatPattern: "[A-Za-z0-9 ]{1,12}",
			  messages: {
				  "isRequired": "Please select a state.",
				  "pattern": "The value you entered exceeds the 12 alpha-numeric limit."
			  }

		  },
  		  {
  			  elemKey: "js-gender",
  			  messages: { "isRequired": "Please select a gender." }
  	      },
  	  ]
    },



    {
  	  formKey: "upgradeForm",
  	  inputList: [
		  {
			  elemKey: "js-firstName",
			  formatPattern: "[A-Za-z ]{1,30}",
			    messages: {
			    	"isRequired": "Please enter a valid first name" ,
				    "pattern": "Valid characters are A-Z a-z 0 upto 30 character long.",
			    }
		  },
		  {
			  elemKey: "js-lastName",
			  formatPattern: "[A-Za-z ]{1,30}",
			  messages: {
				  "isRequired": "Please enter a valid last name.",
				  "pattern": "Valid characters are A-Z a-z 0 upto 30 character long.",
			  }
		  },
		  {
			  elemKey: "js-email",
			  messages: {
				  "isRequired": "Please enter a valid email address.",
				  "email": "Only valid email address is allowed."
			  }
		  },
		  {
			  elemKey: "js-country",
			  messages: {
				  "isRequired": "Please select a country.",
				  "pattern": "Valid characters are A-Z, a-z, space and  upto 30 character long.",
				    }
		  },
		  {
			  elemKey: "js-zipcode",
			  formatPattern: "[A-Za-z0-9 -]{1,10}",
			  messages: {
				  "isRequired": "Please enter a valid zipcode." ,
				  "pattern": "Please enter alpha-numeric value and upto 10 character long.",}
		  },
		  {
  			  elemKey: "js-city",
  			  formatPattern: "[A-Za-z0-9 _.\/#,-]{1,30}",
  			  messages: {
  				  "isRequired": "Please enter a city.",
  				  "pattern": "Please enter alpha-numeric value and upto 30 character long."
  			  }
		  },
		  {
			  elemKey: "js-address",
			  formatPattern: "[A-Za-z0-9 _.\/#,-]{1,30}",
			  messages: {
				  "isRequired": "Please enter your address.",
				  "pattern": "Please enter alpha-numeric value and upto 30 character long.",
			  }
		  },
		  {
			  elemKey: "js-address2",
			  formatPattern: "[A-Za-z0-9 _.\/#,-]{1,30}",
			  messages: {
			  		"pattern": "Please enter alpha-numeric value and upto 30 character long.",
			  }
		  },
		  {
  			  elemKey: "js-state",
  			  formatPattern: "[A-Za-z0-9 ]{1,12}",
  			  messages: {
  				  "isRequired": "Please select a state.",
  				  "pattern": "The value you entered exceeds the 12 alpha-numeric limit."
  			  }

		  },
  		  {
  		    elemKey: "js-tos",
  		    messages: { "isRequired": "You must confirm shipping address." }
  		  },
  	  ]
    },


    {
    	  formKey: "profileForm",
    	  inputList: [
    		  {
    			  elemKey: "js-firstName",
    			  formatPattern: "[A-Za-z ]{1,30}",
    			    messages: {
    			    	"isRequired": "Please enter a valid first name" ,
    				    "pattern": "Valid characters are A-Z a-z 0 upto 30 character long.",
    			    }
    		  },
    		  {
    			  elemKey: "js-lastName",
    			  formatPattern: "[A-Za-z ]{1,30}",
    			  messages: {
    				  "isRequired": "Please enter a valid last name.",
    				  "pattern": "Valid characters are A-Z a-z 0 upto 30 character long.",
				  }
    		  },
    		  {
    			  elemKey: "js-email",
    			  messages: {
    				  "isRequired": "Please enter a valid email address.",
    				  "email": "Only valid email address is allowed."
    			  }
    		  },
    		  {
    			  elemKey: "js-country",
    			  messages: {
    				  "isRequired": "Please select a country.",
    				  "pattern": "Valid characters are A-Z, a-z, space and  upto 30 character long.",
  				    }
    		  },
    		  {
    			  elemKey: "js-zipcode",
    			  formatPattern: "[A-Za-z0-9 -]{1,10}",
    			  messages: {
    				  "isRequired": "Please enter a valid zipcode." ,
    				  "pattern": "Please enter alpha-numeric value and upto 10 character long.",
    			}
    		  },
    		  {
      			  elemKey: "js-city",
      			  formatPattern: "[A-Za-z0-9 _.\/#,-]{1,30}",
      			  messages: {
      				  "isRequired": "Please enter a city.",
      				  "pattern": "Please enter alpha-numeric value and upto 30 character long."
      			  }
    		  },
    		  {
    			  elemKey: "js-address",
    			  formatPattern: "[A-Za-z0-9 _.\/#,-]{1,30}",
    			  messages: {
    				  "isRequired": "Please enter your address.",
    				  "pattern": "Please enter alpha-numeric value and upto 30 character long.",
    			  }
    		  },
    		  {
    			  elemKey: "js-address2",
    			  formatPattern: "[A-Za-z0-9 _.\/#,-]{1,30}",
    			  messages: {
				  		"pattern": "Please enter alpha-numeric value and upto 30 character long.",
    			  }
    		  },
    		  {
      			  elemKey: "js-state",
      			  formatPattern: "[A-Za-z0-9 ]{1,12}",
      			  messages: {
      				  "isRequired": "Please select a state.",
      				  "pattern": "The value you entered exceeds the 12 alpha-numeric limit."
      			  }

    		  }
    	  ]
      }


];

